import notificationInfoDataset from "../../datasets/notification_info_dataset";

export const createNotificationObj = (notificationName, additionalInfo) => {
    // this is used for one time notifications (awards earned and others)
    let notificationObj = {};
    let notificationInfoObj = notificationInfoDataset.find(elem => elem.notificationName === notificationName);
    if (notificationInfoObj){
        notificationObj = {variety: "notification", 
                category: notificationInfoObj.notificationCategory,
                type: notificationInfoObj.notificationName,
                additionalInfo: "",
                imageSrc: notificationInfoObj.imageSrc};
        if (additionalInfo){
            notificationObj.additionalInfo = additionalInfo;
        }
    }
    return notificationObj;
}
export default createNotificationObj;